(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/views/init-tabs.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/views/init-tabs.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.terms_integrity=_svs.terms_integrity||{};
_svs.terms_integrity.templates=_svs.terms_integrity.templates||{};
svs.terms_integrity.templates.init_tabs = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"terms-integrity-tabview\" class=\"rsInverted-large bg-white\">\n\n\n</div>\n";
},"useData":true});
Handlebars.partials['svs-terms_integrity-init_tabs'] = svs.terms_integrity.templates.init_tabs;
})(svs, Handlebars);

 })(window);